import useGetProjectFolders, {
  TFolder,
} from '@/api/queries/project/useGetProjectFolders';
import CreateEditFolderModal from '@/ui/pages/projectPage/components/FilesPanel/components/CreateEditFolderModal';
import DeleteFolderModal from '@/ui/pages/projectPage/components/FilesPanel/components/DeleteFolderModal';
import FolderCard from '@/ui/pages/projectPage/components/FilesPanel/components/FolderCard';
import { buildFolderToPath } from '@/ui/pages/projectPage/components/FilesPanel/utils';
import { FC, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

export type TProps = {
  projectId: string;
  workingFolder?: TFolder;
};

const FoldersList: FC<TProps> = (props) => {
  const { projectId, workingFolder } = props;

  const { url } = useRouteMatch();

  const {
    projectFolders,
    projectRootFolder,
    isLoading: isLoadingProjectFolders,
    nonRootProjectFolders,
  } = useGetProjectFolders(projectId);

  const parentFolder = projectFolders?.find(
    (folder) => folder.id === workingFolder?.parentId
  );

  const [isRenameModalOpen, setIsRenameModalOpen] = useState<
    TFolder | undefined
  >(undefined);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<
    TFolder | undefined
  >(undefined);

  if (nonRootProjectFolders?.length === 0 && !isLoadingProjectFolders) {
    return null;
  }

  return (
    <>
      {/*Folders*/}
      <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-4">
        {isLoadingProjectFolders && (
          <>
            <FolderCard.Loading />
            <FolderCard.Loading />
          </>
        )}

        {!!parentFolder && (
          <FolderCard
            id={parentFolder.id}
            folderName={parentFolder.isRoot ? 'Files' : parentFolder.name}
            to={buildFolderToPath(url, parentFolder)}
            icon="flip-backward.3"
          />
        )}

        {projectFolders
          ?.filter(
            (folder) =>
              folder.parentId ===
              (workingFolder?.id || projectRootFolder?.id || null)
          )
          .map((folder) => (
            <FolderCard
              id={folder.id}
              key={folder.id}
              folderName={folder.name}
              to={buildFolderToPath(url, folder)}
              contextMenuItems={[
                {
                  label: 'Rename',
                  onClick: (event) => {
                    event.stopPropagation();
                    setIsRenameModalOpen(folder);
                  },
                },
                {
                  label: 'Delete',
                  disabled: !folder.isDeletable.result,
                  disabledReasons: folder.isDeletable.reasons || undefined,
                  onClick: (event) => {
                    event.stopPropagation();
                    setIsDeleteModalOpen(folder);
                  },
                },
              ]}
            />
          ))}
      </div>

      <hr />

      <CreateEditFolderModal
        projectId={projectId}
        folder={isRenameModalOpen}
        isOpen={!!isRenameModalOpen}
        onClose={() => setIsRenameModalOpen(undefined)}
      />

      <DeleteFolderModal
        projectId={projectId}
        folder={isDeleteModalOpen}
        isOpen={!!isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(undefined)}
      />
    </>
  );
};

export default FoldersList;
